import React from 'react';
import { Globe, Check } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { useLanguage } from '../i18n/LanguageContext';

export const LanguageDropdown = () => {
  const { lang, setLang, langs, t } = useLanguage();
  const current = langs.find(l => l.code === lang);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-dropdown-trigger"
          aria-label={t('nav.language')}
          className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 hover:border-[#8B2C3A] hover:text-[#8B2C3A] transition-colors"
        >
          <Globe className="w-4 h-4" />
          <span>{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {langs.map(l => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onSelect={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span>{l.label}</span>
            {l.code === lang && <Check className="w-4 h-4 text-[#8B2C3A]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const LanguageBar = () => {
  const { lang, setLang, langs } = useLanguage();
  return (
    <div className="flex items-center gap-1 text-sm font-semibold" data-testid="language-bar">
      {langs.map((l, i) => (
        <React.Fragment key={l.code}>
          {i > 0 && <span className="text-emerald-200/70">|</span>}
          <button
            type="button"
            data-testid={`language-bar-${l.code}`}
            onClick={() => setLang(l.code)}
            aria-pressed={lang === l.code}
            title={l.label}
            className={`min-w-[2rem] px-2 py-0.5 rounded leading-5 transition-colors ${lang === l.code ? 'bg-white text-emerald-700' : 'text-white hover:bg-white/20'}`}
          >
            {l.short}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};
